import { Component } from '@theme/component';
import { SubscriptionUpdateEvent } from '@theme/events';
import { ThemeEvents } from '@theme/events';

/**
 * @typedef {object} SubscriptionUpsellRefs
 * @property {HTMLInputElement[]} inputs – The input elements.
 * @property {HTMLElement[]} [inputs]
 */

/**
 * A custom element that manages a subscription upsell.
 *
 * @template {import('@theme/component').Refs} [TRefs=SubscriptionUpsellRefs]
 * @extends Component<TRefs>
 */
export default class SubscriptionUpsell extends Component {
  connectedCallback() {
    super.connectedCallback();
    // @ts-ignore
    document.addEventListener(ThemeEvents.subscriptionUpdate, this.#subscriptionUpdate.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * Handles seubscription plan update events
   * @param {CustomEvent} event - The sunscription update event
   */
  #subscriptionUpdate(event) {
    if (!(event instanceof SubscriptionUpdateEvent)) return;
    const subscriptionPlanId = event.detail.subscriptionPlanId;
    if (subscriptionPlanId) {
      // @ts-ignore
      this.refs.inputs?.forEach((/** @type {{ disabled: boolean; }} */ input) => {
        input.disabled = false;
      });
    } else {
      // @ts-ignore
      this.refs.inputs?.forEach((/** @type {{ disabled: boolean; }} */ input) => {
        input.disabled = true;
      });
    }
  }
}

if (!customElements.get('subscription-upsell')) {
  customElements.define('subscription-upsell', SubscriptionUpsell);
}
